// 分拣中心
const CenterForSorting = {
  pleaseChoose: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Favor selecionar'
  },
  pleaseInput: {
    zh: '请输入',
    en: 'Please enter the content',
    pu: 'Por favor digite'
  },
  add: {
    zh: '新增',
    en: 'add',
    pu: 'Novo'
  },
  search: {
    zh: '查询',
    en: 'Search',
    pu: 'Consultar'
  },
  reset: {
    zh: '重置',
    en: 'reset',
    pu: 'Resetar'
  },
  startTime: {
    zh: '开始时间',
    en: 'Start time',
    pu: 'Horário de início'
  },
  endTime: {
    zh: '结束时间',
    en: 'End time',
    pu: 'Horário de término'
  },
  export: {
    zh: '导出',
    en: 'export',
    pu: 'Exportar'
  },
  State: {
    zh: '状态',
    en: 'state',
    pu: 'status'
  },
  accountState: {
    zh: '状态：',
    en: 'state：',
    pu: 'status：'
  },
  note: {
    zh: '备注：',
    en: 'remark: ',
    pu: 'observações: '
  },
  Note: {
    zh: '备注',
    en: 'remark',
    pu: 'observações'
  },
  Save: {
    zh: '保存',
    en: 'Save',
    pu: 'Salvar'
  },
  modify: {
    zh: '修改',
    en: 'modify',
    pu: 'modificar'
  },
  cancel: {
    zh: '取消',
    en: 'cancel',
    pu: 'cancelar'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'Editar'
  },
  operation: {
    zh: '操作',
    en: 'operation',
    pu: 'Operação'
  },
  ind: {
    zh: '序号',
    en: 'index',
    pu: 'Número de série.'
  },
  state: {
    zh: '州',
    en: 'state',
    pu: 'Estado'
  },
  CreationTime: {
    zh: '创建时间',
    en: 'Creation time',
    pu: 'Tempo de criação'
  },
  creator: {
    zh: '创建人',
    en: 'creator',
    pu: 'Criado por'
  },
  ModificationTime: {
    zh: '修改时间',
    en: 'Modification time',
    pu: 'Tempo de modificação'
  },
  ModifiedBy: {
    zh: '修改人',
    en: 'Modified by',
    pu: 'Modificado por'
  },
  enable: {
    zh: '启用',
    en: 'enable',
    pu: 'Ativar'
  },
  notEnabled: {
    zh: '未启用',
    en: 'Not enabled',
    pu: 'desativo'
  },
  Lattice: {
    zh: '格口',
    en: 'Lattice',
    pu: 'Reticulado'
  },
  Editor: {
    zh: '编辑人',
    en: 'Editor',
    pu: 'Editor'
  },
  EditTime: {
    zh: '编辑时间',
    en: 'Edit time',
    pu: 'Hora de edição'
  },
  Delete: {
    zh: '删除',
    en: 'Delete',
    pu: 'Excluir'
  },
  AreYouSureDelete: {
    zh: '确定删除吗？',
    en: 'Are you sure to delete it',
    pu: 'Tem certeza de apagar?'
  },
  DeleteSucceeded: {
    zh: '删除成功',
    en: 'Delete succeeded',
    pu: 'Excluir foi bem sucedido'
  },
  notNull: {
    zh: '不能为空',
    en: 'Cannot be empty',
    pu: 'Não pode estar vazio'
  },
  CityName: {
    zh: '城市名称',
    en: 'City Name',
    pu: 'Cidade'
  },
  ZipCodeAreaName: {
    zh: '邮编分区名称：',
    en: 'Zip Code Area Name:',
    pu: 'Divisão de Código Postal：'
  },
  CityN: {
    zh: '城市名称：',
    en: 'City Name:',
    pu: 'Cidade：'
  },
  StateTwoCode: {
    zh: '州二字码',
    en: 'State Two Code',
    pu: 'Código de Dois Caracteres do Estado'
  },
  AddedZipCodeArea: {
    zh: '新增邮编分区',
    en: 'Added Zip Code Area',
    pu: 'Nova Divisão de Código Postal'
  },
  ZipCodeAreaNo: {
    zh: '邮编分区编号',
    en: 'Zip Code Area No',
    pu: 'Número de Divisão do Código Postal'
  },
  ZipCodeAreaNum: {
    zh: '邮编分区编号：',
    en: 'Zip Code Area No:',
    pu: 'Número de Divisão do Código Postal'
  },
  ZipCodeAreaN: {
    zh: '邮编分区名称',
    en: 'Zip Code Area Name',
    pu: 'Divisão do Código Postal'
  },
  RuleName: {
    zh: '规则名称',
    en: 'Rule Name',
    pu: 'Nome de Regra'
  },
  ZipCodeArea: {
    zh: '邮编分区',
    en: 'Zip Code Area',
    pu: 'Divisão de Código Postal'
  },
  ZipCodeAreaNotEmpty: {
    zh: '邮编分区不能为空',
    en: 'Zip Code Area Cannot be empty',
    pu: 'A divisão de Código Postal não pode estar vazia'
  },
  gekouNotNull: {
    zh: '格口不能为空',
    en: 'Container cannot be empty',
    pu: 'A saca não pode estar vazia'
  },
  gekouAdd: {
    zh: '新增格口',
    en: 'Add contentor',
    pu: 'Gerar nova saca'
  },
  gekouEdit: {
    zh: '编辑格口',
    en: 'Modify container information',
    pu: 'Modificar a informação da saca'
  },
  ImmediatelyCreate: {
    zh: '立即创建',
    en: 'Immediately Create',
    pu: 'criar imediatamente'
  },
  newAddSuc: {
    zh: '新增成功',
    en: 'Add Success',
    pu: 'adicionar com sucesso'
  },
  EditSuccessful: {
    zh: '修改成功',
    en: 'Modification successful',
    pu: 'Modificação bem sucedida'
  },
  SerialNumber: {
    zh: '编号：',
    en: 'Serial Number:',
    pu: 'Número：'
  },
  ZipCodeAreaRange: {
    zh: '邮编分区范围',
    en: 'Zip Code Area Range',
    pu: 'Zona de Divisão de Código Postal'
  },
  LatticePortNumber: {
    zh: '格口编号',
    en: 'Lattice Port Number',
    pu: 'Número de saca'
  },
  LatticePortNum: {
    zh: '格口编号：',
    en: 'Lattice Port Number:',
    pu: 'Número de saca：'
  },
  ClearCache: {
    zh: '清除缓存',
    en: 'Clear cache',
    pu: 'Cache claro'
  },
  packageSum: {
    zh: '小包数量',
    en: 'Package Sum',
    pu: 'Número de pacotes'
  },
  Print: {
    zh: '打印',
    en: 'Print',
    pu: 'Imprimir'
  },
  orderNumber: {
    zh: '订单号',
    en: 'orderNumber：',
    pu: 'Número do pedido：'
  },
  bigBagNum: {
    zh: '大包号',
    en: 'Big Bag Num',
    pu: 'Grande bolsa'
  },
  bigBagNumber: {
    zh: '大包号：',
    en: 'Big Bag Num:',
    pu: 'Grande bolsa：'
  },
  orderNum: {
    zh: '订单号',
    en: 'The order number',
    pu: 'Número do pedido'
  },
  ReferenceNumber: {
    zh: '参考号',
    en: 'Reference number',
    pu: 'No. Ref. Da Anjun'
  },
  OutLibrary: {
    zh: '已出库',
    en: 'Out of the library',
    pu: 'Fora do armazém'
  },
  orderStatus: {
    zh: '出入库状态',
    en: 'Order Status',
    pu: 'Status na armazém'
  },
  NotInStorage: {
    zh: '未入库',
    en: 'Not In Storage',
    pu: 'Não estar na armazém'
  },
  InStorage: {
    zh: '已入库',
    en: 'In Storage',
    pu: 'Está na armazém'
  },
  sorterOrder: {
    zh: '分拣订单',
    en: 'Sorter Order',
    pu: 'ordem de classificação'
  },
  channel: {
    zh: '渠道',
    en: 'channel',
    pu: 'Canal'
  },
  RuleImport: {
    zh: '规则导入',
    en: 'Rule Import',
    pu: 'As regras para importar'
  },
  Import: {
    zh: '导入',
    en: 'Import',
    pu: 'Importação'
  },
  TemplateDownload: {
    zh: '模版下载',
    en: 'Template Download',
    pu: 'Download do modelo'
  },
  FileUpload: {
    zh: '文件上传',
    en: 'File Upload',
    pu: 'Carregamento de arquivos'
  },
  AssociationRules: {
    zh: '关联规则',
    en: 'Association Rules',
    pu: 'Regras de associação'
  },
  sortingRules: {
    zh: '分拣规则',
    en: 'Sorting Rules',
    pu: 'Regras de Classificação'
  },
  enabledRuleGroup: {
    zh: '启用规则组',
    en: 'Enabled Rule Group',
    pu: 'Grupo de Regras Ativado'
  },
  noEnabledRuleGroup: {
    zh: '未启用规则组',
    en: 'No Enabled Rule Group',
    pu: 'Nenhum Grupo de Regras Ativado'
  },
  // Machine Management
  machine: { zh: '设备', en: 'Device', pu: 'Dispositivo' },
  machineName: { zh: '设备名称', en: 'Device Name', pu: 'Nome do Dispositivo' },
  machineCode: { zh: '设备编码', en: 'Device Code', pu: 'Código do Dispositivo' },
  all: { zh: '全部', en: 'All', pu: 'Todos' },
  disable: { zh: '停用', en: 'Disable', pu: 'Desativar' },
  newMachine: { zh: '新增设备', en: 'Add Device', pu: 'Novo Dispositivo' },
  transferWarehouse: { zh: '中转仓', en: 'Transfer Warehouse', pu: 'Armazém de Transferência' },
  chuteCount: { zh: '格口数', en: 'Chute Count', pu: 'Contagem de Chutes' },
  deviceStatus: { zh: '设备状态', en: 'Device Status', pu: 'Status do Dispositivo' },
  operatingStatus: { zh: '运行状态', en: 'Operating Status', pu: 'Status Operacional' },
  running: { zh: '运行', en: 'Running', pu: 'Executando' },
  shutdown: { zh: '关机', en: 'Shutdown', pu: 'Desligado' },
  unknown: { zh: '未知', en: 'Unknown', pu: 'Desconhecido' },
  chuteView: { zh: '格口视图', en: 'Chute View', pu: 'Visão do Chute' },
  editMachine: { zh: '编辑设备', en: 'Edit Device', pu: 'Editar Dispositivo' },
  authSecretKey: { zh: '授权秘钥', en: 'Auth Secret Key', pu: 'Chave Secreta de Autenticação' },
  transferWarehouseCode: {
    zh: '中转仓编码',
    en: 'Transfer Warehouse Code',
    pu: 'Código do Armazém de Transferência'
  },
  chuteNum: { zh: '格口数量', en: 'Chute Number', pu: 'Número de Chutes' },
  chuteCountTip: {
    zh: '修改格口数前请确保无启用的规则组',
    en: 'Ensure no active rule groups before modifying chute count',
    pu: 'Certifique-se de que não haja grupos de regras ativos antes de modificar a contagem de chutes'
  },
  scanRegex: { zh: '扫描正则', en: 'Scan Regex', pu: 'Regex de Digitalização' },
  dataSource: { zh: '数据来源', en: 'Data Source', pu: 'Fonte de Dados' },
  uploadOnDrop: { zh: '落袋上传', en: 'Upload on Drop', pu: 'Upload ao Cair' },
  scanChute: { zh: '扫描格口', en: 'Scan Chute', pu: 'Digitalizar Chute' },
  confirm: { zh: '确认', en: 'Confirm', pu: 'Confirmar' },
  success: { zh: '成功', en: 'Success', pu: 'Sucesso' },
  createSuccess: { zh: '创建成功', en: 'Created Successfully', pu: 'Criado com Sucesso' },
  updateSuccess: { zh: '更新成功', en: 'Updated Successfully', pu: 'Atualizado com Sucesso' },
  operateSuccess: { zh: '操作成功', en: 'Operation Successful', pu: 'Operação Bem-sucedida' },
  confirmStatusChange: {
    zh: '确认要{status}该设备吗?',
    en: 'Are you sure to {status} this device?',
    pu: 'Tem certeza de que deseja {status} este dispositivo?'
  },
  tips: { zh: '提示', en: 'Tips', pu: 'Dicas' },
  sure: { zh: '确定', en: 'Sure', pu: 'Claro' },
  updateChuteFailTip: {
    zh: '基本信息已更新，但格口数量修改失败（可能存在启用规则组）',
    en: 'Basic info updated, but chute count modification failed (active rule groups may exist)',
    pu: 'Informações básicas atualizadas, mas a modificação da contagem de chutes falhou (podem existir grupos de regras ativos)'
  },
  deviceInfo: { zh: '设备信息', en: 'Device Info', pu: 'Informações do Dispositivo' },
  backToList: { zh: '返回列表', en: 'Back to List', pu: 'Voltar para a Lista' },
  totalChutes: { zh: '格口总数', en: 'Total Chutes', pu: 'Total de Chutes' },
  closedChutes: { zh: '关闭格口数', en: 'Closed Chutes', pu: 'Chutes Fechados' },
  fullBagChutes: { zh: '满袋格口数', en: 'Full Bag Chutes', pu: 'Chutes com Sacola Cheia' },
  refresh: { zh: '刷新', en: 'Refresh', pu: 'Atualizar' },
  autoRefresh: { zh: '自动刷新', en: 'Auto Refresh', pu: 'Atualização Automática' },
  closeAutoRefresh: {
    zh: '关闭自动刷新',
    en: 'Close Auto Refresh',
    pu: 'Fechar Atualização Automática'
  },
  refresh30s: { zh: '30秒刷新', en: 'Refresh every 30s', pu: 'Atualizar a cada 30s' },
  refresh60s: { zh: '60秒刷新', en: 'Refresh every 60s', pu: 'Atualizar a cada 60s' },
  open: { zh: '开启', en: 'Open', pu: 'Abrir' },
  close: { zh: '关闭', en: 'Close', pu: 'Fechar' },
  fullBag: { zh: '满袋', en: 'Full Bag', pu: 'Sacola Cheia' },
  noRule: { zh: '无规则', en: 'No Rule', pu: 'Sem Regra' },
  bagCount: { zh: '落袋数', en: 'Bag Count', pu: 'Contagem de Sacolas' },
  setFull: { zh: '设为满袋', en: 'Set as Full', pu: 'Definir como Cheio' },
  clearData: { zh: '清理数据', en: 'Clear Data', pu: 'Limpar Dados' },
  chuteDetail: { zh: '格口详情', en: 'Chute Detail', pu: 'Detalhes do Chute' },
  fullBagNotice: {
    zh: '格口满袋消息通知',
    en: 'Full Bag Notifications',
    pu: 'Notificações de Sacola Cheia'
  },
  fullBagNoticeTip: {
    zh: '以下格口已满袋，请及时更换集包袋',
    en: 'The following chutes are full, please replace the bags in time',
    pu: 'Os chutes abaixo estão cheios, troque as sacolas a tempo'
  },
  noFullBagNotice: {
    zh: '暂无满袋消息通知',
    en: 'No full bag notifications',
    pu: 'Nenhuma notificação de sacola cheia'
  },
  recoverNormal: {
    zh: '恢复正常',
    en: 'Recovered',
    pu: 'Recuperado'
  },
  clickLoadMore: {
    zh: '点击查看更多',
    en: 'Click to load more',
    pu: 'Clique para carregar mais'
  },
  chuteNo: { zh: '格口号', en: 'Chute No', pu: 'Nº do Chute' },
  currentStatus: { zh: '当前状态', en: 'Current Status', pu: 'Status Atual' },
  bindRule: { zh: '绑定规则', en: 'Bind Rule', pu: 'Vincular Regra' },
  none: { zh: '无', en: 'None', pu: 'Nenhum' },
  ruleId: { zh: '规则ID', en: 'Rule ID', pu: 'ID da Regra' },
  confirmClearData: {
    zh: '确认要清理格口 {chuteNo} 的数据吗?',
    en: 'Are you sure to clear data for chute {chuteNo}?',
    pu: 'Tem certeza de limpar os dados do chute {chuteNo}?'
  },
  clearSuccess: { zh: '清理成功', en: 'Cleared Successfully', pu: 'Limpo com Sucesso' },
  statusUpdateSuccess: { zh: '更新成功', en: 'Updated Successfully', pu: 'Atualizado com Sucesso' },
  noDeviceId: {
    zh: '未指定设备ID',
    en: 'Device ID not specified',
    pu: 'ID do dispositivo não especificado'
  },
  copyRule: { zh: '复制规则', en: 'Copy Rule', pu: 'Copiar Regra' },
  sourceMachine: { zh: '源设备', en: 'Source Device', pu: 'Dispositivo de Origem' },
  sourceRuleGroup: { zh: '源规则组', en: 'Source Rule Group', pu: 'Grupo de Regras de Origem' },
  pleaseSelectRules: {
    zh: '请选择要复制的规则',
    en: 'Please select rules to copy',
    pu: 'Por favor, selecione as regras para copiar'
  },
  copySuccess: { zh: '复制成功', en: 'Copied Successfully', pu: 'Copiado com Sucesso' },
  copyFailed: {
    zh: '部分或全部规则复制失败',
    en: 'Partial or all rules failed to copy',
    pu: 'Falha ao copiar algumas ou todas as regras'
  },
  // Rule Group Management
  ruleGroupName: { zh: '规则组名称', en: 'Rule Group Name', pu: 'Nome do Grupo de Regras' },
  ruleCount: { zh: '规则数', en: 'Rule Count', pu: 'Contagem de Regras' },
  createTime: { zh: '创建时间', en: 'Create Time', pu: 'Hora de Criação' },
  ruleGroupDesc: {
    zh: '规则组描述',
    en: 'Rule Group Description',
    pu: 'Descrição do Grupo de Regras'
  },
  newRuleGroup: { zh: '新增规则组', en: 'Add Rule Group', pu: 'Adicionar Grupo de Regras' },
  editRuleGroup: { zh: '编辑规则组', en: 'Edit Rule Group', pu: 'Editar Grupo de Regras' },
  enableRuleGroupConfirm: {
    zh: '启用后，该设备其他规则组将自动失效，是否继续？',
    en: 'After enabling, other rule groups of this device will be automatically disabled. Continue?',
    pu: 'Após ativar, outros grupos de regras deste dispositivo serão desativados automaticamente. Continuar?'
  },
  enableSuccess: { zh: '启用成功', en: 'Enabled Successfully', pu: 'Ativado com Sucesso' },
  disableSuccess: { zh: '失效成功', en: 'Disabled Successfully', pu: 'Desativado com Sucesso' },
  enabled: { zh: '启用', en: 'Enabled', pu: 'Ativado' },
  disabled: { zh: '失效', en: 'Disabled', pu: 'Desativado' },
  currentDevice: { zh: '当前设备', en: 'Current Device', pu: 'Dispositivo Atual' },
  // Rule Management
  selectRuleGroup: { zh: '选择规则组', en: 'Select Rule Group', pu: 'Selecionar Grupo de Regras' },
  newRule: { zh: '新增规则', en: 'Add Rule', pu: 'Adicionar Regra' },
  noOperatePermission: {
    zh: '当前设备暂无操作权限，请联系管理员',
    en: 'No operation permission for the current device, please contact the administrator',
    pu: 'Sem permissão de operação para o dispositivo atual, contate o administrador'
  },
  otherActions: { zh: '其他操作', en: 'Other Actions', pu: 'Outras Ações' },
  priority: { zh: '优先级', en: 'Priority', pu: 'Prioridade' },
  targetChute: { zh: '目标格口', en: 'Target Chute', pu: 'Chute de Destino' },
  matchLogic: { zh: '匹配逻辑', en: 'Match Logic', pu: 'Lógica de Correspondência' },
  conditionCount: { zh: '条件数量', en: 'Condition Count', pu: 'Contagem de Condições' },
  viewConditions: { zh: '查看条件', en: 'View Conditions', pu: 'Ver Condições' },
  ruleGroupChangeLog: {
    zh: '规则组变更日志',
    en: 'Rule Group Change Logs',
    pu: 'Logs de Alteração do Grupo de Regras'
  },
  ruleChangeLog: { zh: '规则变更日志', en: 'Rule Change Logs', pu: 'Logs de Alteração de Regras' },
  ruleChangeLogSentence: {
    zh: '{user} 在 {time} {action}',
    en: '{user} at {time} {action}',
    pu: '{user} em {time} {action}'
  },
  viewChangeDetail: {
    zh: '查看变更详情',
    en: 'View Change Details',
    pu: 'Ver Detalhes da Alteração'
  },
  changeCompareTitle: {
    zh: '新旧值对比',
    en: 'Before/After Comparison',
    pu: 'Comparação Antes/Depois'
  },
  changeField: { zh: '变更字段', en: 'Changed Field', pu: 'Campo Alterado' },
  beforeData: { zh: '变更前', en: 'Before', pu: 'Antes' },
  afterData: { zh: '变更后', en: 'After', pu: 'Depois' },
  noMoreData: { zh: '没有更多数据了', en: 'No more data', pu: 'Não há mais dados' },
  loading: { zh: '加载中...', en: 'Loading...', pu: 'Carregando...' },
  editRule: { zh: '编辑规则', en: 'Edit Rule', pu: 'Editar Regra' },
  editEnabledRule: { zh: '编辑启用规则', en: 'Edit Enabled Rule', pu: 'Editar Regra Ativada' },
  forceChange: { zh: '强制变更', en: 'Force Change', pu: 'Alteração Forçada' },
  deleteRule: { zh: '删除规则', en: 'Delete Rule', pu: 'Excluir Regra' },
  ruleDesc: { zh: '规则描述', en: 'Rule Description', pu: 'Descrição da Regra' },
  addCondition: { zh: '新增条件', en: 'Add Condition', pu: 'Adicionar Condição' },
  conditionType: { zh: '条件类型', en: 'Condition Type', pu: 'Tipo de Condição' },
  operator: { zh: '运算符', en: 'Operator', pu: 'Operador' },
  conditionValue: { zh: '条件值', en: 'Condition Value', pu: 'Valor da Condição' },
  deleteCondition: { zh: '删除条件', en: 'Delete Condition', pu: 'Excluir Condição' },
  ruleName: { zh: '规则名称', en: 'Rule Name', pu: 'Nome da Regra' },
  condition: { zh: '条件', en: 'Condition', pu: 'Condição' },
  chuteDuplicate: {
    zh: '格口号重复',
    en: 'Duplicate Chute Number',
    pu: 'Número do Chute Duplicado'
  },
  dragTip: {
    zh: '可拖动排序，拖动排序会重新排序所有的规则',
    en: 'Drag to sort. Sorting will reorder all rules.',
    pu: 'Arraste para classificar. A classificação reorganizará todas as regras.'
  },
  enableSort: {
    zh: '启用拖动排序',
    en: 'Enable drag sorting',
    pu: 'Habilitar ordenação por arrasto'
  },
  // Operators
  CREATE: { zh: '创建规则', en: 'Create Rule', pu: 'Criar Regra' },
  UPDATE: { zh: '修改规则', en: 'Update Rule', pu: 'Atualizar Regra' },
  DELETE: { zh: '删除规则', en: 'Delete Rule', pu: 'Excluir Regra' },
  ENABLE: { zh: '启用规则组', en: 'Enable Rule Group', pu: 'Ativar Grupo de Regras' },
  DISABLE: { zh: '失效规则组', en: 'Disable Rule Group', pu: 'Desativar Grupo de Regras' },
  EQ: { zh: '等于', en: 'Equal', pu: 'Igual' },
  NE: { zh: '不等于', en: 'Not Equal', pu: 'Não Igual' },
  GT: { zh: '大于', en: 'Greater Than', pu: 'Maior Que' },
  LT: { zh: '小于', en: 'Less Than', pu: 'Menor Que' },
  LTE: { zh: '小于等于', en: 'Less Than or Equal', pu: 'Menor ou Igual' },
  IN: { zh: '包含', en: 'In', pu: 'Contém' },
  NOT_IN: { zh: '不包含', en: 'Not In', pu: 'Não incluso' },
  BETWEEN: { zh: '在范围内', en: 'Between', pu: 'Entre' },
  CONTAINS: { zh: '包含', en: 'Contains', pu: 'Contém' },
  // Condition Types
  MDFE: { zh: 'MDFE未关闭', en: 'MDFE Not Closed', pu: 'MDFE Não Fechado' },
  PROBLEM_PIECE: { zh: '问题件', en: 'Problem Piece', pu: 'Peça com Problema' },
  CARRIER: { zh: '服务商', en: 'Carrier', pu: 'Transportadora' },
  CUSTOMER: { zh: '客户', en: 'Customer', pu: 'Cliente' },
  NETWORK_POINT: { zh: '网点', en: 'Network Point', pu: 'Ponto de Rede' },
  SORT_FAIL: {
    zh: '分拣失败次数',
    en: 'Number of sorting failures',
    pu: 'Número de falhas na triagem'
  },
  TRANSFER_CENTER: { zh: '转运中心', en: 'Transfer Center', pu: 'Centro de Transferência' },
  WAYBILL_STATUS: { zh: '运单状态', en: 'Waybill Status', pu: 'Status da Carta de Porte' },
  ZIP_CODE: { zh: '邮编范围', en: 'Zip Code Range', pu: 'Faixa de CEP' },
  PROBLEM_PIECE_STATUS: {
    zh: '问题件状态',
    en: 'Problem Piece Status',
    pu: 'Status da Peça com Problema'
  },
  PACKAGE_WEIGHT: { zh: '包裹重量(kg)', en: 'Package Weight (kg)', pu: 'Peso do Pacote (kg)' },
  DEFAULT: { zh: '系统兜底规则', en: 'System fallback rule', pu: 'Regra de fallback do sistema' },
  MACHINE_FALLBACK: {
    zh: '分拣机兜底规则',
    en: 'Machine fallback rule',
    pu: 'Regra de fallback da máquina'
  },
  INSUFFICIENT_PREPAID_FUNDS: {
    zh: '预存资金不足',
    en: 'System fallback rule',
    pu: 'Saldo insuficiente'
  },
  // 分拣规则-网点刷新提示
  networkPointRefreshTipBefore: {
    zh: '如果无法选中网点，请',
    en: 'If you cannot select a network point, please',
    pu: 'Se não conseguir selecionar um ponto de rede, por favor'
  },
  networkPointRefreshLink: { zh: '点击刷新', en: 'click to refresh', pu: 'clique para atualizar' },
  networkPointRefreshTipAfter: {
    zh: '后再尝试。已停用的网点或无派送邮编范围的网点无法作为目的地。',
    en: ' and try again. Disabled network points or those without a delivery zip code range cannot be used as destinations.',
    pu: ' e tente novamente. Pontos de rede desativados ou sem faixa de CEP de entrega não podem ser usados como destino.'
  },
  networkPointRefreshSuccess: {
    zh: '网点数据已更新',
    en: 'Network point data updated',
    pu: 'Dados do ponto de rede atualizados'
  },
  networkPointRefreshFailed: {
    zh: '刷新失败，请稍后重试',
    en: 'Refresh failed, please try again later',
    pu: 'Falha ao atualizar, tente novamente mais tarde'
  },
  // Logic
  AND: { zh: '满足所有条件(AND)', en: 'Match All (AND)', pu: 'Corresponder a Todos (AND)' },
  OR: { zh: '满足任一条件(OR)', en: 'Match Any (OR)', pu: 'Corresponder a Qualquer (OR)' },
  yes: { zh: '是', en: 'Yes', pu: 'Sim' },
  no: { zh: '否', en: 'No', pu: 'Não' },
  // Sorting Record
  scanNumber: { zh: '扫描单号', en: 'Scan Number', pu: 'Número de Digitalização' },
  scanGrid: { zh: '扫描格口号', en: 'Scan Grid', pu: 'Grade de Digitalização' },
  waybillNumber: { zh: '运单号', en: 'Waybill Number', pu: 'Número da Carta de Porte' },
  sortingStatus: { zh: '分拣状态', en: 'Sorting Status', pu: 'Status de Classificação' },
  matchRule: { zh: '匹配规则', en: 'Match Rule', pu: 'Regra de Correspondência' },
  timeRange: { zh: '时间范围', en: 'Time Range', pu: 'Intervalo de Tempo' },
  failReason: { zh: '失败原因', en: 'Fail Reason', pu: 'Motivo da Falha' },
  sortSuccess: { zh: '分拣成功', en: 'Sort Success', pu: 'Sucesso na Classificação' },
  sortFail: { zh: '分拣失败', en: 'Sort Fail', pu: 'Falha na Classificação' },
  waybillDropMeasure: {
    zh: '运单落格测算',
    en: 'Waybill Chute Measurement',
    pu: 'Medição de Chute da Carta de Porte'
  },
  requestNumber: { zh: '单号', en: 'Request Number', pu: 'Número da Solicitação' },
  measureMachineRequired: {
    zh: '请选择分拣机',
    en: 'Please select a sorting machine',
    pu: 'Selecione uma máquina de triagem'
  },
  measureNumberRequired: {
    zh: '请输入需要测算的单号',
    en: 'Please input request numbers to measure',
    pu: 'Insira os números de solicitação para medir'
  },
  // Upload Record
  bagNumber: { zh: '封袋号', en: 'Bag Number', pu: 'Número da Sacola' },
  weight: { zh: '重量', en: 'Weight', pu: 'Peso' },
  length: { zh: '长', en: 'Length', pu: 'Comprimento' },
  width: { zh: '宽', en: 'Width', pu: 'Largura' },
  height: { zh: '高', en: 'Height', pu: 'Altura' },
  weightWithUnit: { zh: '重量(kg)', en: 'Weight(kg)', pu: 'Peso(kg)' },
  lengthWithUnit: { zh: '长度(cm)', en: 'Length(cm)', pu: 'Comprimento(cm)' },
  widthWithUnit: { zh: '宽度(cm)', en: 'Width(cm)', pu: 'Largura(cm)' },
  heightWithUnit: { zh: '高度(cm)', en: 'Height(cm)', pu: 'Altura(cm)' },
  pictureUrl: { zh: '图片', en: 'Picture', pu: 'Imagem' },
  uploadStatus: { zh: '状态', en: 'Status', pu: 'Status' },
  statusUploaded: { zh: '落袋', en: 'Uploaded', pu: 'Carregado' },
  statusBagged: { zh: '已封袋', en: 'Bagged', pu: 'Ensacado' },
  statusCleaning: { zh: '清理', en: 'Cleaning', pu: 'Limpeza' },
  statusRemovedFromBag: { zh: '移除出袋', en: 'Removed from bag', pu: 'Removido da sacola' },
  doBagging: { zh: '封袋', en: 'Bagging', pu: 'Ensacamento' },
  baggingConfirm: { zh: '封袋确认', en: 'Bagging Confirm', pu: 'Confirmação de Ensacamento' },
  baggingSuccess: { zh: '封袋成功', en: 'Bagging Success', pu: 'Sucesso no Ensacamento' },
  inputBagNumber: {
    zh: '请输入封袋号',
    en: 'Please input bag number',
    pu: 'Por favor, insira o número da sacola'
  },
  previewPackage: { zh: '包裹预览', en: 'Package Preview', pu: 'Visualização do Pacote' },
  barcode: { zh: '条形码', en: 'Barcode', pu: 'Código de Barras' },
  ruleConditionDetail: {
    zh: '规则条件详情',
    en: 'Rule Condition Details',
    pu: 'Detalhes da Condição da Regra'
  },
  usingRuleGroup: { zh: '使用规则组', en: 'Using Rule Group', pu: 'Grupo de Regras em Uso' },
  ruleMatchHint: {
    zh: '配置的规则会按照优先级来匹配，一旦匹配成功，则返回该规则配置的格口。',
    en: 'Rules are matched by priority. Once matched, the configured chute is returned.',
    pu: 'As regras são correspondidas por prioridade. Uma vez correspondida, o chute configurado é retornado.'
  },
  ruleMatchStep1: { zh: '匹配规则1', en: 'Match Rule 1', pu: 'Corresponder à Regra 1' },
  ruleMatchStep2: { zh: '匹配规则2', en: 'Match Rule 2', pu: 'Corresponder à Regra 2' },
  ruleMatchSuccess: { zh: '匹配成功', en: 'Match Success', pu: 'Correspondência com Sucesso' },
  returnChute: { zh: '返回格口', en: 'Return Chute', pu: 'Retornar Chute' },
  continueMatch: { zh: '继续匹配', en: 'Continue Match', pu: 'Continuar Correspondência' },
  ruleMatchExplanation: {
    zh: '系统按优先级依次匹配规则，一旦匹配成功立即返回对应格口，不再匹配后续规则。',
    en: 'The system matches rules by priority. Once matched, it returns the chute immediately and stops matching.',
    pu: 'O sistema corresponde às regras por prioridade. Uma vez correspondido, retorna o chute imediatamente e para.'
  },
  timeRangeRequired: {
    zh: '查询时间范围不能为空',
    en: 'Query time range cannot be empty',
    pu: 'O intervalo de tempo da consulta não pode estar vazio'
  },
  queryTimeLimit: {
    zh: '查询时间范围不能超过7天',
    en: 'Query time range cannot exceed 7 days',
    pu: 'O intervalo de tempo da consulta não pode exceder 7 dias'
  },
  invalidChuteId: {
    zh: '无效的格口ID',
    en: 'Invalid Chute ID',
    pu: 'ID do chute inválido'
  },
  noRuleConditions: {
    zh: '暂无规则条件',
    en: 'No rule conditions available',
    pu: 'Nenhuma condição de regra disponível'
  },
  conditionNotEmpty: {
    zh: '规则条件不能为空',
    en: 'Rule conditions cannot be empty',
    pu: 'As condições da regra não podem estar vazias'
  },
  isFallback: {
    zh: '是否兜底规则',
    en: 'Fallback Rule Type',
    pu: 'Tipo de regra de fallback'
  },
  isMachineFallbackRule: {
    zh: '分拣机兜底',
    en: 'Machine Fallback',
    pu: 'Fallback da Máquina'
  },
  systemFallback: {
    zh: '系统兜底',
    en: 'System Fallback',
    pu: 'Fallback do Sistema'
  },
  machineFallback: {
    zh: '分拣机兜底',
    en: 'Machine Fallback',
    pu: 'Fallback da Máquina'
  },
  systemFallbackTooltip: {
    zh: '系统兜底表示在所有规则都没有匹配上的情况下，将命中此规则',
    en: 'System fallback means this rule is matched when no other rules are matched.',
    pu: 'Fallback do sistema significa que esta regra será aplicada quando nenhuma outra regra for correspondida.'
  },
  machineFallbackTooltip: {
    zh: '分拣机兜底表示分拣机获取此项配置，在分拣机扫描识别异常、接口超时、包裹不在小车上等分拣机的异常事件，将命中此规则',
    en: 'Machine fallback means this rule is used for machine-side exception events, such as scan recognition failure, API timeout, or package not on trolley.',
    pu: 'Fallback da máquina significa que esta regra será usada em eventos de exceção da máquina, como falha de leitura, timeout da API ou pacote fora do carrinho.'
  },
  isAbnormalRule: {
    zh: '是否异常规则',
    en: 'Is Abnormal Rule',
    pu: 'É regra anormal'
  },
  abnormal: {
    zh: '异常',
    en: 'Abnormal',
    pu: 'Anormal'
  },
  fallback: {
    zh: '系统兜底',
    en: 'System Fallback',
    pu: 'Fallback do Sistema'
  },
  machineFallbackTag: {
    zh: '设备兜底',
    en: 'Device Fallback',
    pu: 'Fallback do Dispositivo'
  },
  // Zip Range Component
  zipRangeConfig: {
    zh: '邮编范围配置',
    en: 'Zip Code Range Config',
    pu: 'Configuração de Faixa de CEP'
  },
  noData: {
    zh: '暂无数据',
    en: 'No Data',
    pu: 'Sem Dados'
  },
  startZip: {
    zh: '起始邮编',
    en: 'Start Zip Code',
    pu: 'CEP Inicial'
  },
  endZip: {
    zh: '结束邮编',
    en: 'End Zip Code',
    pu: 'CEP Final'
  },
  addZipRange: {
    zh: '新增邮编范围',
    en: 'Add Zip Range',
    pu: 'Adicionar Faixa de CEP'
  },
  zipFormatError: {
    zh: '邮编格式错误，请输入8位数字',
    en: 'Zip code format error, please enter 8 digits',
    pu: 'Erro no formato do CEP, insira 8 dígitos'
  },
  startGreaterThanEnd: {
    zh: '起始邮编不能大于结束邮编',
    en: 'Start zip code cannot be greater than end zip code',
    pu: 'O CEP inicial não pode ser maior que o CEP final'
  },
  startZipRequired: {
    zh: '请输入起始邮编',
    en: 'Please enter start zip code',
    pu: 'Por favor, insira o CEP inicial'
  },
  overlapError: {
    zh: '{range1}与{range2}重叠',
    en: '{range1} overlaps with {range2}',
    pu: '{range1} sobrepõe-se a {range2}'
  },
  zipDistribution: {
    zh: '邮编分布示意图',
    en: 'Zip Code Distribution',
    pu: 'Distribuição de CEP'
  },
  zipCode: {
    zh: '邮编',
    en: 'Zip Code',
    pu: 'CEP'
  },
  zipSchematicHint: {
    zh: '仅示意范围关系，不表示实际距离',
    en: 'Schematic only, not actual distance',
    pu: 'Apenas esquemático, não representa distância real'
  },
  ruleGroupEnabledTip: {
    zh: '规则组已启用，需要禁用规则组才能编辑和删除',
    en: 'The rule group is enabled. You need to disable the rule group to edit or delete.',
    pu: 'O grupo de regras está ativado. Você precisa desativar o grupo de regras para editar ou excluir.'
  },
  fallbackRuleTip: {
    zh: '必须配置一组系统兜底规则。系统兜底规则用于在所有条件均未命中时，按优先级返回对应格口进行容错处理。',
    en: 'A system fallback rule is required. When no conditions are matched, the system returns the chute of the system fallback rule by priority for fault tolerance.',
    pu: 'É necessário configurar uma regra de fallback do sistema. Quando nenhuma condição for correspondida, o sistema retorna o chute da regra de fallback do sistema por prioridade para tolerância a falhas.'
  },
  baggingType: {
    zh: '落袋类型',
    en: 'Bagging Type',
    pu: 'Tipo de Ensacamento'
  },
  normalBagging: {
    zh: '正常落袋',
    en: 'Normal Bagging',
    pu: 'Ensacamento Normal'
  },
  fallbackBagging: {
    zh: '兜底规则落袋',
    en: 'Fallback Rule Bagging',
    pu: 'Ensacamento por Regra de Fallback'
  },
  abnormalBagging: {
    zh: '异常件落袋',
    en: 'Abnormal Package Bagging',
    pu: 'Ensacamento de Pacote Anormal'
  },
  supplyTable: {
    zh: '供包台',
    en: 'Supply Table',
    pu: 'Mesa de Fornecimento'
  },
  personAccount: {
    zh: '供包台账号',
    en: 'Supply Table Account',
    pu: 'Conta da Mesa de Fornecimento'
  },
  supplyTime: {
    zh: '供包时间',
    en: 'Supply Time',
    pu: 'Hora de Fornecimento'
  },
  Perus011: {
    zh: '人工供包台1',
    en: 'Manual Feeding Station 1',
    pu: 'Estação de Alimentação Manual 1'
  },
  Perus012: {
    zh: '人工供包台2',
    en: 'Manual Feeding Station 2',
    pu: 'Estação de Alimentação Manual 2'
  },
  Perus013: {
    zh: '人工供包台3',
    en: 'Manual Feeding Station 3',
    pu: 'Estação de Alimentação Manual 3'
  },
  Perus014: {
    zh: '人工供包台4',
    en: 'Manual Feeding Station 4',
    pu: 'Estação de Alimentação Manual 4'
  },
  Perus015: {
    zh: '人工供包台5',
    en: 'Manual Feeding Station 5',
    pu: 'Estação de Alimentação Manual 5'
  },
  Perus016: {
    zh: '人工供包台6',
    en: 'Manual Feeding Station 6',
    pu: 'Estação de Alimentação Manual 6'
  },
  'AJ-GRU1': {
    zh: '下层人工供包台1',
    en: 'Lower Manual Feeding Station 1',
    pu: 'Estação de Alimentação Manual Inferior 1'
  },
  'AJ-GRU2': {
    zh: '下层人工供包台2',
    en: 'Lower Manual Feeding Station 2',
    pu: 'Estação de Alimentação Manual Inferior 2'
  },
  'AJ-GRU3': {
    zh: '下层人工供包台3',
    en: 'Lower Manual Feeding Station 3',
    pu: 'Estação de Alimentação Manual Inferior 3'
  },
  'AJ-GRU4': {
    zh: '下层人工供包台4',
    en: 'Lower Manual Feeding Station 4',
    pu: 'Estação de Alimentação Manual Inferior 4'
  },
  'AJ-GRU5': {
    zh: '下层人工供包台5',
    en: 'Lower Manual Feeding Station 5',
    pu: 'Estação de Alimentação Manual Inferior 5'
  },
  'AJ-GRU6': {
    zh: '下层人工供包台6',
    en: 'Lower Manual Feeding Station 6',
    pu: 'Estação de Alimentação Manual Inferior 6'
  },
  'AJ-GRU7': {
    zh: '下层人工供包台7',
    en: 'Lower Manual Feeding Station 7',
    pu: 'Estação de Alimentação Manual Inferior 7'
  },
  'AJ-GRU8': {
    zh: '下层自动供包台1',
    en: 'Lower Automatic Feeding Station 1',
    pu: 'Estação de Alimentação Automática Inferior 1'
  },
  'AJ-GRU9': {
    zh: '下层自动供包台2',
    en: 'Lower Automatic Feeding Station 2',
    pu: 'Estação de Alimentação Automática Inferior 2'
  },
  'AJ-GRU10': {
    zh: '下层自动供包台3',
    en: 'Lower Automatic Feeding Station 3',
    pu: 'Estação de Alimentação Automática Inferior 3'
  },
  'AJ-GRU11': {
    zh: '下层自动供包台4',
    en: 'Lower Automatic Feeding Station 4',
    pu: 'Estação de Alimentação Automática Inferior 4'
  },
  'AJ-GRU12': {
    zh: '下层自动供包台5',
    en: 'Lower Automatic Feeding Station 5',
    pu: 'Estação de Alimentação Automática Inferior 5'
  },
  'AJ-GRU13': {
    zh: '上层人工供包台1',
    en: 'Upper Manual Feeding Station 1',
    pu: 'Estação de Alimentação Manual Superior 1'
  },
  'AJ-GRU14': {
    zh: '上层人工供包台2',
    en: 'Upper Manual Feeding Station 2',
    pu: 'Estação de Alimentação Manual Superior 2'
  },
  'AJ-GRU15': {
    zh: '上层人工供包台3',
    en: 'Upper Manual Feeding Station 3',
    pu: 'Estação de Alimentação Manual Superior 3'
  },
  'AJ-GRU16': {
    zh: '上层人工供包台4',
    en: 'Upper Manual Feeding Station 4',
    pu: 'Estação de Alimentação Manual Superior 4'
  },
  'AJ-GRU17': {
    zh: '上层人工供包台5',
    en: 'Upper Manual Feeding Station 5',
    pu: 'Estação de Alimentação Manual Superior 5'
  },
  'AJ-GRU18': {
    zh: '上层人工供包台6',
    en: 'Upper Manual Feeding Station 6',
    pu: 'Estação de Alimentação Manual Superior 6'
  },
  'AJ-GRU19': {
    zh: '上层人工供包台7',
    en: 'Upper Manual Feeding Station 7',
    pu: 'Estação de Alimentação Manual Superior 7'
  },
  'AJ-GRU20': {
    zh: '上层自动供包台1',
    en: 'Upper Automatic Feeding Station 1',
    pu: 'Estação de Alimentação Automática Superior 1'
  },
  'AJ-GRU21': {
    zh: '上层自动供包台2',
    en: 'Upper Automatic Feeding Station 2',
    pu: 'Estação de Alimentação Automática Superior 2'
  },
  'AJ-GRU22': {
    zh: '上层自动供包台3',
    en: 'Upper Automatic Feeding Station 3',
    pu: 'Estação de Alimentação Automática Superior 3'
  },
  'AJ-GRU23': {
    zh: '上层自动供包台4',
    en: 'Upper Automatic Feeding Station 4',
    pu: 'Estação de Alimentação Automática Superior 4'
  },
  'AJ-GRU24': {
    zh: '上层自动供包台5',
    en: 'Upper Automatic Feeding Station 5',
    pu: 'Estação de Alimentação Automática Superior 5'
  },
  repeatBaggingCount: {
    zh: '重复落袋次数',
    en: 'Repeat Bagging Count',
    pu: 'Contagem de Ensacamento Repetido'
  },
  description: {
    zh: '描述',
    en: 'Description',
    pu: 'Descrição'
  },
  operateUser: {
    zh: '关联操作用户',
    en: 'Operate User',
    pu: 'Usuário Operacional'
  },
  invalidRegex: {
    zh: '正则表达式格式错误',
    en: 'Invalid Regex Format',
    pu: 'Formato de Regex Inválido'
  },
  testRegex: {
    zh: '测试正则',
    en: 'Test Regex',
    pu: 'Testar Regex'
  },
  regexPass: {
    zh: '通过',
    en: 'Pass',
    pu: 'Passou'
  },
  regexFail: {
    zh: '不通过',
    en: 'Fail',
    pu: 'Falhou'
  },
  inputTestString: {
    zh: '输入单号测试',
    en: 'Input tracking number to test',
    pu: 'Insira o número de rastreamento para testar'
  },
  removeFromBag: {
    zh: '移除出袋',
    en: 'Remove from bag',
    pu: 'Remover da sacola'
  },
  confirmRemoveFromBag: {
    zh: '确认要移除出袋吗？',
    en: 'Are you sure to remove from bag?',
    pu: 'Tem certeza de que deseja remover da sacola?'
  },
  removeSuccess: {
    zh: '移除成功',
    en: 'Remove from bag successfully',
    pu: 'Removido da sacola com sucesso'
  },
  noChangeLogData: {
    zh: '没有变更日志',
    en: 'No changelog',
    pu: 'Sem registro de alterações'
  },
  multipleChutesInput: {
    zh: '多个格口请换行输入',
    en: 'One chute per line',
    pu: 'Uma comporta por linha'
  },
  sortingMetricReport: {
    zh: '分拣数量统计',
    en: 'Sorting Metric Report',
    pu: 'Relatorio de Quantidade de Triagem'
  },
  sortingMetricReportDesc: {
    zh: '围绕总量趋势、环比概览、维度排行和下钻趋势联动设计，适用于运营看板与现场管理报表。',
    en: 'Built for overview trends, comparison insights, dimension rankings, and drill-down trend linkage.',
    pu: 'Projetado para tendencia geral, comparacao, ranking dimensional e vinculacao de drill-down.'
  },
  sortingStatisticType: {
    zh: '统计类型',
    en: 'Metric Type',
    pu: 'Tipo de Estatistica'
  },
  screeningConditions: {
    zh: '筛选条件',
    en: 'Filters',
    pu: 'Filtros'
  },
  sortingChuteStat: {
    zh: '格口统计',
    en: 'Chute Metrics',
    pu: 'Estatisticas de Chute'
  },
  sortingChuteStatDesc: {
    zh: '关注格口袋数变化、累计吞吐与热点格口。',
    en: 'Focus on bag count changes, cumulative throughput, and hotspot chutes.',
    pu: 'Foco em variacao de sacolas, throughput acumulado e chutes quentes.'
  },
  sortingSupplyTableStat: {
    zh: '供包台统计',
    en: 'Supply Table Metrics',
    pu: 'Estatisticas da Mesa de Fornecimento'
  },
  sortingSupplyTableStatDesc: {
    zh: '关注供包台上件活跃度与吞吐峰值分布。',
    en: 'Focus on activity and throughput peak distribution by supply table.',
    pu: 'Foco em atividade e distribuicao de pico por mesa de fornecimento.'
  },
  sortingRuleHitStat: {
    zh: '规则命中统计',
    en: 'Rule Hit Metrics',
    pu: 'Estatisticas de Acerto de Regra'
  },
  sortingRuleHitStatDesc: {
    zh: '关注规则命中量、规则热度与命中波动。',
    en: 'Focus on hit volume, rule popularity, and hit fluctuation.',
    pu: 'Foco em volume de acerto, popularidade da regra e flutuacao.'
  },
  sortingTimeDimension: {
    zh: '时间维度',
    en: 'Time Dimension',
    pu: 'Dimensao de Tempo'
  },
  sortingByHour: {
    zh: '按小时',
    en: 'By Hour',
    pu: 'Por Hora'
  },
  sortingByDay: {
    zh: '按天',
    en: 'By Day',
    pu: 'Por Dia'
  },
  sortingByWeek: {
    zh: '按周',
    en: 'By Week',
    pu: 'Por Semana'
  },
  sortingByMonth: {
    zh: '按月',
    en: 'By Month',
    pu: 'Por Mes'
  },
  sortingCustomTime: {
    zh: '自定义时间段',
    en: 'Custom Range',
    pu: 'Periodo Personalizado'
  },
  sortingCurrentTotal: {
    zh: '当前区间累计',
    en: 'Current Total',
    pu: 'Total Atual'
  },
  sortingPreviousTotal: {
    zh: '对比区间累计',
    en: 'Previous Total',
    pu: 'Total Comparativo'
  },
  sortingCompareRatio: {
    zh: '环比概览',
    en: 'Comparison Ratio',
    pu: 'Razao Comparativa'
  },
  sortingPeakValue: {
    zh: '峰值点位',
    en: 'Peak Point',
    pu: 'Ponto de Pico'
  },
  sortingTopDimension: {
    zh: '热点维度',
    en: 'Top Dimension',
    pu: 'Dimensao Mais Quente'
  },
  sortingOverviewTrend: {
    zh: '总量趋势',
    en: 'Overview Trend',
    pu: 'Tendencia Geral'
  },
  sortingDimensionRanking: {
    zh: '维度排行',
    en: 'Dimension Ranking',
    pu: 'Ranking Dimensional'
  },
  sortingRankingTip: {
    zh: '支持点击排行柱条联动下方维度详情趋势，维度较多时可滚动查看。',
    en: 'Click ranking bars to link dimension detail trends. Scroll when dimensions are many.',
    pu: 'Clique nas barras para vincular a tendencia detalhada. Role quando houver muitas dimensoes.'
  },
  sortingActiveDimensions: {
    zh: '维度覆盖数',
    en: 'Dimension Count',
    pu: 'Contagem de Dimensoes'
  },
  sortingDimensionSummary: {
    zh: '维度摘要',
    en: 'Dimension Summary',
    pu: 'Resumo Dimensional'
  },
  sortingDrillTip: {
    zh: '点击任一维度行，可联动右侧趋势图查看该维度的走势与环比。',
    en: 'Click a dimension row to update the detail trend and comparison on the right.',
    pu: 'Clique em uma linha para atualizar a tendencia detalhada e a comparacao.'
  },
  sortingDimensionName: {
    zh: '维度名称',
    en: 'Dimension Name',
    pu: 'Nome da Dimensao'
  },
  sortingRealtime: {
    zh: '实时',
    en: 'Realtime',
    pu: 'Tempo Real'
  },
  sortingDetailTrend: {
    zh: '详情趋势',
    en: 'Detail Trend',
    pu: 'Tendencia Detalhada'
  },
  sortingSelectDimensionTip: {
    zh: '请选择一个维度查看趋势。',
    en: 'Select a dimension to view the trend.',
    pu: 'Selecione uma dimensao para ver a tendencia.'
  },
  sortingRealtimeIncluded: {
    zh: '已叠加实时数据',
    en: 'Realtime included',
    pu: 'Dados em tempo real incluidos'
  },
  sortingHistoryOnly: {
    zh: '历史区间数据',
    en: 'Historical interval data',
    pu: 'Dados historicos'
  },
  sortingHasCompareData: {
    zh: '存在有效对比区间',
    en: 'Comparison available',
    pu: 'Comparacao disponivel'
  },
  sortingNoCompareData: {
    zh: '对比区间不可用',
    en: 'Comparison unavailable',
    pu: 'Comparacao indisponivel'
  },
  sortingTrendUp: {
    zh: '当前趋势上升',
    en: 'Upward trend',
    pu: 'Tendencia de alta'
  },
  sortingTrendDown: {
    zh: '当前趋势回落',
    en: 'Downward trend',
    pu: 'Tendencia de queda'
  },
  sortingTrendFlat: {
    zh: '当前趋势平稳',
    en: 'Stable trend',
    pu: 'Tendencia estavel'
  },
  sortingBagCount: {
    zh: '袋数',
    en: 'Bag Count',
    pu: 'Contagem de Sacolas'
  },
  sortingCumulativeThroughput: {
    zh: '累计吞吐',
    en: 'Cumulative Throughput',
    pu: 'Throughput Acumulado'
  },
  sortingSupplyCount: {
    zh: '上件量',
    en: 'Supply Volume',
    pu: 'Volume de Alimentacao'
  },
  sortingHitCount: {
    zh: '命中量',
    en: 'Hit Count',
    pu: 'Contagem de Acertos'
  },
  sortingCumulativeHit: {
    zh: '累计命中',
    en: 'Cumulative Hits',
    pu: 'Acertos Acumulados'
  },
  sortingMetricDescLabel: {
    zh: '指标说明',
    en: 'Metric Notes',
    pu: 'Notas do Indicador'
  },
  sortingReportTimeRange: {
    zh: '报表时间范围',
    en: 'Report Time Range',
    pu: 'Periodo do Relatorio'
  },
  sortingAutoRefreshTip: {
    zh: '页面数据每2秒自动刷新',
    en: 'Auto refresh every 2 seconds',
    pu: 'Atualizacao automatica a cada 2 segundos'
  },
  sortingLastRefresh: {
    zh: '最近刷新',
    en: 'Last Refresh',
    pu: 'Ultima Atualizacao'
  },
  sortingChuteName: {
    zh: '格口名称',
    en: 'Chute Name',
    pu: 'Nome do Chute'
  },
  sortingSupplyTableName: {
    zh: '供包台名称',
    en: 'Supply Table Name',
    pu: 'Nome da Mesa de Fornecimento'
  },
  sortingRuleName: {
    zh: '规则名称',
    en: 'Rule Name',
    pu: 'Nome da Regra'
  },
  sortingChutePeakValue: {
    zh: '落袋峰值',
    en: 'Bagging Peak',
    pu: 'Pico de Ensacamento'
  },
  sortingSupplyPeakValue: {
    zh: '供包上件峰值',
    en: 'Supply Peak',
    pu: 'Pico de Alimentacao'
  },
  sortingRulePeakValue: {
    zh: '规则命中峰值',
    en: 'Rule Hit Peak',
    pu: 'Pico de Acertos da Regra'
  },
  sortingTopChute: {
    zh: '热点格口',
    en: 'Top Chute',
    pu: 'Chute Mais Quente'
  },
  sortingTopSupplyTable: {
    zh: '热点供包台',
    en: 'Top Supply Table',
    pu: 'Mesa Mais Quente'
  },
  sortingTopRule: {
    zh: '热点规则',
    en: 'Top Rule',
    pu: 'Regra Mais Quente'
  },
  sortingTopChuteTip: {
    zh: '该时间段内落袋包裹最多的格口',
    en: 'The chute with the most bagged parcels in this time range',
    pu: 'O chute com mais pacotes ensacados neste periodo'
  },
  sortingTopSupplyTableTip: {
    zh: '该时间段内供包上件包裹最多的供包台',
    en: 'The supply table with the most supplied parcels in this time range',
    pu: 'A mesa com mais pacotes alimentados neste periodo'
  },
  sortingTopRuleTip: {
    zh: '该时间段内命中次数最多的规则',
    en: 'The most frequently hit rule in this time range',
    pu: 'A regra com maior numero de acertos neste periodo'
  },
  sortingChuteOverviewTrend: {
    zh: '格口总量趋势',
    en: 'Chute Total Trend',
    pu: 'Tendencia Total do Chute'
  },
  sortingSupplyOverviewTrend: {
    zh: '供包上件量趋势',
    en: 'Supply Volume Trend',
    pu: 'Tendencia de Volume de Alimentacao'
  },
  sortingRuleOverviewTrend: {
    zh: '规则命中趋势',
    en: 'Rule Hit Trend',
    pu: 'Tendencia de Acertos da Regra'
  },
  sortingChuteRanking: {
    zh: '格口累计落袋排行',
    en: 'Chute Bagging Ranking',
    pu: 'Ranking de Ensacamento por Chute'
  },
  sortingSupplyRanking: {
    zh: '供包上件量排行',
    en: 'Supply Volume Ranking',
    pu: 'Ranking de Volume de Alimentacao'
  },
  sortingRuleRanking: {
    zh: '规则命中排行',
    en: 'Rule Hit Ranking',
    pu: 'Ranking de Acertos da Regra'
  },
  sortingChuteCountTotal: {
    zh: '统计格口总数',
    en: 'Total Chutes',
    pu: 'Total de Chutes'
  },
  sortingSupplyTableCountTotal: {
    zh: '供包台总数',
    en: 'Total Supply Tables',
    pu: 'Total de Mesas de Fornecimento'
  },
  sortingRuleCountTotal: {
    zh: '规则总数',
    en: 'Total Rules',
    pu: 'Total de Regras'
  },
  sortingChuteRankingTip: {
    zh: '支持点击排行柱条联动下方维度详情趋势，格口较多时可滚动查看。',
    en: 'Click ranking bars to link the detail trend below. Scroll when many chutes exist.',
    pu: 'Clique nas barras para vincular a tendencia detalhada abaixo. Role quando houver muitos chutes.'
  },
  sortingSupplyRankingTip: {
    zh: '支持点击排行柱条联动下方维度详情趋势，供包台较多时可滚动查看。',
    en: 'Click ranking bars to link the detail trend below. Scroll when many supply tables exist.',
    pu: 'Clique nas barras para vincular a tendencia detalhada abaixo. Role quando houver muitas mesas.'
  },
  sortingRuleRankingTip: {
    zh: '支持点击排行柱条联动下方维度详情趋势，规则较多时可滚动查看。',
    en: 'Click ranking bars to link the detail trend below. Scroll when many rules exist.',
    pu: 'Clique nas barras para vincular a tendencia detalhada abaixo. Role quando houver muitas regras.'
  },
  sortingChuteSummary: {
    zh: '格口数据概览',
    en: 'Chute Overview',
    pu: 'Visao Geral do Chute'
  },
  sortingSupplySummary: {
    zh: '供包台数据概览',
    en: 'Supply Table Overview',
    pu: 'Visao Geral da Mesa de Fornecimento'
  },
  sortingRuleSummary: {
    zh: '规则命中数据概览',
    en: 'Rule Hit Overview',
    pu: 'Visao Geral de Acertos da Regra'
  },
  sortingChuteDrillTip: {
    zh: '点击任一格口行，可联动右侧趋势图查看该格口的走势与环比。',
    en: 'Click any chute row to view its trend and comparison in the chart on the right.',
    pu: 'Clique em qualquer linha de chute para ver sua tendencia e comparacao no grafico da direita.'
  },
  sortingSupplyDrillTip: {
    zh: '点击任一供包台行，可联动右侧趋势图查看该供包台的走势与环比。',
    en: 'Click any supply table row to view its trend and comparison in the chart on the right.',
    pu: 'Clique em qualquer linha da mesa para ver sua tendencia e comparacao no grafico da direita.'
  },
  sortingRuleDrillTip: {
    zh: '点击任一规则行，可联动右侧趋势图查看该规则命中的走势与环比。',
    en: 'Click any rule row to view its hit trend and comparison in the chart on the right.',
    pu: 'Clique em qualquer linha de regra para ver sua tendencia de acertos e comparacao no grafico da direita.'
  },
  sortingChuteDetailTrend: {
    zh: '格口落袋趋势图',
    en: 'Chute Bagging Trend',
    pu: 'Grafico de Tendencia de Ensacamento do Chute'
  },
  sortingSupplyDetailTrend: {
    zh: '供包台上件趋势图',
    en: 'Supply Table Trend',
    pu: 'Grafico de Tendencia da Mesa de Fornecimento'
  },
  sortingRuleDetailTrend: {
    zh: '规则命中趋势图',
    en: 'Rule Hit Trend Chart',
    pu: 'Grafico de Tendencia de Acertos da Regra'
  },
  sortingActualBagCount: {
    zh: '实际落袋包裹',
    en: 'Actual Bagged Parcels',
    pu: 'Pacotes Ensacados Reais'
  },
  sortingCumulativeBaggingCount: {
    zh: '累计落袋包裹（含重复落袋）',
    en: 'Cumulative Bagged Parcels',
    pu: 'Pacotes Ensacados Acumulados'
  },
  sortingCumulativeSupplyCount: {
    zh: '累计上件量',
    en: 'Cumulative Supply Volume',
    pu: 'Volume Acumulado de Alimentacao'
  },
  manualSupplyTable: {
    zh: '人工供包台',
    en: 'Manual Supply Table',
    pu: 'Mesa de Fornecimento Manual'
  },
  allSupplyTableType: {
    zh: '全部供包台',
    en: 'All Supply Tables',
    pu: 'Todas as Mesas de Fornecimento'
  },
  automaticSupplyTable: {
    zh: '自动供包台',
    en: 'Automatic Supply Table',
    pu: 'Mesa de Fornecimento Automatica'
  },
  selectMachineFirst: {
    zh: '请选择分拣机',
    en: 'Please select a sorting machine',
    pu: 'Selecione uma maquina de triagem'
  },
  downloadImage: {
    zh: '下载图片',
    en: 'Download Image',
    pu: 'Baixar Imagem'
  },
  downloadImageSuccess: {
    zh: '图片下载成功',
    en: 'Image downloaded successfully',
    pu: 'Imagem baixada com sucesso'
  },
  downloadImageFailed: {
    zh: '图片下载失败',
    en: 'Failed to download image',
    pu: 'Falha ao baixar imagem'
  },
  downloadImageUnavailable: {
    zh: '当前图表暂无可下载内容',
    en: 'No chart content available for download',
    pu: 'Nenhum conteudo de grafico disponivel para download'
  },
  maxTwoParentRules: {
    zh: '最多只能选两个父级规则',
    en: 'Maximum two parent rules allowed',
    pu: 'Máximo de duas regras pai permitidas'
  },
  ruleExplainTitle: {
    zh: '规则解释：',
    en: 'Rule Explanation:',
    pu: 'Explicação da Regra:'
  },
  ruleExplainParentChildLabel: {
    zh: '【父级/子级】',
    en: '[Parent/Child]',
    pu: '[Pai/Filho]'
  },
  ruleExplainParentChildText: {
    zh: '最多只能选两个父级规则，一旦选择父级规则，那么这条规则就是子级规则',
    en: 'At most two parent rules can be selected. Once a parent rule is selected, this rule becomes a child rule.',
    pu: 'No máximo duas regras pai podem ser selecionadas. Ao selecionar uma regra pai, esta regra se torna uma regra filha.'
  },
  ruleExplainPriorityLabel: {
    zh: '【优先级】',
    en: '[Priority]',
    pu: '[Prioridade]'
  },
  ruleExplainPriorityText: {
    zh: '优先级在前的规则一旦匹配成功立即返回对应格口，则不再匹配后续规则',
    en: 'Once a higher-priority rule is matched, the corresponding chute is returned immediately and subsequent rules are no longer matched.',
    pu: 'Uma vez que uma regra de maior prioridade seja correspondida, o chute correspondente é retornado imediatamente e as regras seguintes não são mais correspondidas.'
  },
  ruleExplainConfigLabel: {
    zh: '【配置方式】',
    en: '[Configuration]',
    pu: '[Configuração]'
  },
  ruleExplainConfigText: {
    zh: '子级规则的优先级一定要在父级规则之前，那么匹配到子级规则后，会返回子级+父级的所有格口，便于分拣机就近落格',
    en: 'The child rule must have a higher priority than the parent rule. When the child rule is matched, all chutes of both child and parent rules are returned, allowing the sorter to drop to the nearest chute.',
    pu: 'A regra filha deve ter prioridade maior que a regra pai. Quando a regra filha é correspondida, todos os chutes da regra filha e da regra pai são retornados, permitindo que a triadora solte no chute mais próximo.'
  },
  exportRules: {
    zh: '导出规则',
    en: 'Export Rules',
    pu: 'Exportar Regras'
  },
  disableRuleGroupConfirm: {
    zh: '确认要停用该规则组吗?新的规则组如需启用，需要清理所有包裹、清理所有格口数据.',
    en: 'Are you sure to disable this rule group? To enable a new rule group, you need to clear all packages and clear all chute data.',
    pu: 'Tem certeza de que deseja desativar este grupo de regras? Para ativar um novo grupo de regras, é necessário limpar todos os pacotes e limpar todos os dados dos chutes.'
  },
  confirmClearAllData: {
    zh: '确认要<span style="color: red; font-weight: bold;">清理全部格口</span>的数据吗？',
    en: 'Are you sure you want to <span style="color: red; font-weight: bold;">clear data for ALL chutes</span>?',
    pu: 'Tem certeza de que deseja <span style="color: red; font-weight: bold;">limpar os dados de TODAS as calhas</span>?'
  },
  confirmCloseAllChutes: {
    zh: '确认要<span style="color: red; font-weight: bold;">关闭所有格口</span>吗？',
    en: 'Are you sure you want to <span style="color: red; font-weight: bold;">close ALL chutes</span>?',
    pu: 'Tem certeza de que deseja <span style="color: red; font-weight: bold;">fechar TODAS as calhas</span>?'
  },
  enableNewRuleGroupNotice: {
    zh: '新的规则组如需启用，需要清理所有包裹、清理所有格口数据。\n启用后，该设备其他规则组将自动失效，是否继续？',
    en: 'To enable a new rule group, you need to clear all packages and all compartment data.\nAfter enabling, other rule groups on this device will be automatically disabled. Continue?',
    pu: 'Para ativar um novo grupo de regras, é necessário limpar todos os pacotes e todos os dados dos compartimentos.\nApós a ativação, os outros grupos de regras neste dispositivo serão automaticamente desativados. Continuar?'
  },
  // ... 原有配置
  bulkImport: {
    zh: '批量导入分拣规则',
    en: 'Bulk Import Sorting Rules',
    pu: 'Importação em massa de regras de classificação'
  },
  uploadRuleFile: {
    zh: '上传分拣规则文件',
    en: 'Upload Sorting Rule File',
    pu: 'Carregar arquivo de regras de classificação'
  },
  dragOrClickUpload: {
    zh: '将文件拖到此处，或点击上传',
    en: 'Drag file here or click to upload',
    pu: 'Arraste o arquivo aqui ou clique para fazer upload'
  },
  ruleTemplateDownload: {
    zh: '分拣规则模板下载',
    en: 'Sorting Rule Template Download',
    pu: 'Download de modelo de regras de classificação'
  },
  downloadTemplate: {
    zh: '下载模板',
    en: 'Download Template',
    pu: 'Baixar modelo'
  },
  fileSizeLimit: {
    zh: '上传文件大小不能超过 10MB!',
    en: 'File size cannot exceed 10MB!',
    pu: 'O tamanho do arquivo não pode exceder 10MB!'
  },
  pleaseSelectFile: {
    zh: '请先选择需要上传的文件',
    en: 'Please select a file to upload first',
    pu: 'Por favor, selecione um arquivo para upload primeiro'
  },
  confirmUpload: {
    zh: '确认上传',
    en: 'Confirm Upload',
    pu: 'Confirmar upload'
  },
  totalRows: {
    zh: '总行数：',
    en: 'Total Rows: ',
    pu: 'Total de linhas: '
  },
  successCount: {
    zh: '成功数：',
    en: 'Success Count: ',
    pu: 'Contagem de sucesso: '
  },
  failCount: {
    zh: '失败数：',
    en: 'Fail Count: ',
    pu: 'Contagem de falhas: '
  },
  importSuccess: {
    zh: '导入成功',
    en: 'Import successful',
    pu: 'Importação bem-sucedida'
  },
  importFailed: {
    zh: '导入失败：',
    en: 'Import failed: ',
    pu: 'Falha na importação: '
  },
  templateDownloadFailed: {
    zh: '模板下载失败',
    en: 'Template download failed',
    pu: 'Falha no download do modelo'
  },
  invalidFileType: {
    zh: '请上传 CSV 或 Excel 文件',
    en: 'Please upload CSV or Excel files',
    pu: 'Por favor, carregue arquivos CSV ou Excel'
  },
  importSuccessTip: {
    zh: '导入成功！请刷新列表查看最新数据',
    en: 'Import successful! Please refresh the list to view latest data',
    pu: 'Importação bem-sucedida! Atualize a lista para ver os dados mais recentes'
  },
  importRules: {
    zh: '导入规则',
    en: 'Import Rules',
    pu: 'Importar Regras'
  }
};
export { CenterForSorting };
